import React, { JSX, ReactNode, useState } from "react";
import classnames from "classnames";
import st from "./expandable.module.scss";

export function Expandable({
  children,
  title,
  className,
}: {
  children: ReactNode | string;
  title: string;
  className?: string;
}): JSX.Element {
  const [visible, setVisible] = useState(false);
  const toggleVisibility = () => setVisible(!visible);

  const chevronClasses = classnames(st.chevron, { [st.up]: visible });
  const contentClasses = classnames(st.content, { [st.visible]: visible });

  return (
    <div className={className}>
      <div
        className={st.expandButton}
        onClick={toggleVisibility}
        onKeyPress={toggleVisibility}
        role="button"
        tabIndex={0}
      >
        {title}
        <div className={chevronClasses} />
      </div>
      <div className={contentClasses}>{children}</div>
    </div>
  );
}
